import { createAsyncThunk } from '@reduxjs/toolkit';
import { GetBlendedSidePolygons, GetBlendedKpiConfig, GetBlendedKpiData, GetBlendedRagThresholds } from '../requests/Beacon4BlendedRequests';

export const loadSides = createAsyncThunk('filters/loadSides',
	async ({ platform, type }, { rejectWithValue }) => {
		try { return (await GetBlendedSidePolygons(platform, type, '')).data; }
		catch (err) { return rejectWithValue(err.response?.data ?? err.message); }
	});

export const loadPolygons = createAsyncThunk('filters/loadPolygons',
	async ({ platform, type, side }, { rejectWithValue }) => {
		try { return (await GetBlendedSidePolygons(platform, type, side)).data; }
		catch (err) { return rejectWithValue(err.response?.data ?? err.message); }
	});

export const loadKpiConfig = createAsyncThunk('kpiData/loadKpiConfig',
	async (_, { rejectWithValue }) => {
		try { return (await GetBlendedKpiConfig()).data; }
		catch (err) { return rejectWithValue(err.response?.data ?? err.message); }
	});

export const loadKpiData = createAsyncThunk('kpiData/loadKpiData',
	async (params, { rejectWithValue }) => {
		try { return (await GetBlendedKpiData(params)).data; }
		catch (err) { return rejectWithValue(err.response?.data ?? err.message); }
	});

export const loadRagThresholds = createAsyncThunk('kpiData/loadRagThresholds',
	async (_, { rejectWithValue }) => {
		try { return (await GetBlendedRagThresholds()).data; }
		catch (err) { return rejectWithValue(err.response?.data ?? err.message); }
	});